import { gql } from '@apollo/client';

const DELETE_COMMENT = gql`mutation deleteComment($commentId:Int!) {
	resourceComments{
		deleteComment (id: $commentId)
	}
}`;

export default DELETE_COMMENT;
